import { getAuditHistoryData, getAuditHistoryByIdData } from "../api"
import { _formatSourceData, _requestReferenceableData } from "../dashboard-data/actions/read"
import { loadAllReferenceableData, constructReferenceableQueryString, getIdsToFetch } from "../cached-data/actions"
import { loadingError, referenceableDataSet } from "../dashboard-data/actions"
import { _post } from "../api/util"
import { urlForResource } from "../common/constants"
import { loadEntities } from "../cached-data/actions"

export const getAuditHistory = (resource, filters) => {
    return dispatch => {
        const promises = []
        resource
            .filter(r => r !== "timelineEntryVersions")
            .forEach(rowResource => {
                promises.push(
                    new Promise((resolve, reject) => {
                        getAuditHistoryData(rowResource, filters).then(
                            data => {
                                resolve({ [rowResource]: data })
                            },
                            err => {
                                reject(err.response.data)
                            }
                        )
                    })
                )
            })

        dispatch(startAuditHistory())
        Promise.all(promises)
            .then(data => {
                const auditData = {}
                data.forEach(value => {
                    Object.entries(value).forEach(entry => {
                        const [key, val] = entry
                        auditData[key] = val
                    })
                })
                dispatch(setAuditHistory(auditData))
            })
            .catch(e => {
                if (e != "abortundefined") {
                    dispatch(loadingError("Something went wrong, please try again later."))
                }
            })
            .finally(() => {
                dispatch(finishAuditHistory())
            })
    }
}

export const getAuditHistoryWithReferenceables = (resource, filters, context) => {
    return (dispatch, getState) => {
        dispatch(startAuditHistory())
        const promises = []
        resource
            .filter(r => r !== "timelineEntryVersions" && r !== "employees")
            .forEach(rowResource => {
                promises.push(
                    new Promise((resolve, reject) => {
                        getAuditHistoryData(rowResource, filters).then(
                            data => {
                                resolve({ [rowResource]: data })
                            },
                            err => {
                                reject(err.response.data)
                            }
                        )
                    })
                )
            })

        const referenceablePromises = []
        let customDashboardData = {}
        Promise.all(promises)
            .then(data => {
                const auditData = {}
                data.forEach(value => {
                    Object.entries(value).forEach(entry => {
                        const [key, val] = entry
                        auditData[key] = val
                    })
                })
                const rawSourceData = data.map(value => {
                    return {
                        resourceName: Object.keys(value)[0],
                        data: value[Object.keys(value)[0]],
                    }
                })

                // This will return the correct referenceable id information for the audit history data
                customDashboardData = _formatSourceData(
                    Object.keys(auditData),
                    rawSourceData,
                    context.settings.relatedNames,
                    true,
                    {},
                    undefined,
                    false,
                    []
                )

                Object.entries(customDashboardData.referenceableIds).forEach(entry => {
                    const [referenceableResource, referenceableIds] = entry
                    const searchByName = (context.settings.referenceablesWithStringIds || []).includes(
                        referenceableResource
                    )
                    if (referenceableIds && referenceableIds.length > 0) {
                        const queryString = constructReferenceableQueryString(
                            referenceableResource,
                            context.settings.referenceableQueryParams?.[referenceableResource] || {}
                        )

                        const body = {}
                        const idsToFetch = getIdsToFetch(referenceableIds, getState(), referenceableResource)

                        // If all requested items are already in the cache, we can just bail out.
                        if (Array.isArray(idsToFetch) && !idsToFetch.length) {
                            return
                        }

                        body["ids"] = idsToFetch
                        const url = searchByName
                            ? `${urlForResource[referenceableResource]}name_filter/?${queryString}`
                            : `${urlForResource[referenceableResource]}id_filter/?${queryString}`
                        const p = _post(url, body, 200, false, false, true)

                        referenceablePromises.push({ resource: referenceableResource, promise: p })
                    }
                })
                referenceablePromises.forEach(resourcePromise => {
                    Promise.resolve(resourcePromise.promise).then(data => {
                        const entities = data.results.reduce((acc, d) => ({ ...acc, [d.id]: d }), {})
                        dispatch(loadEntities({ [resourcePromise.resource]: entities }))
                    })
                })
                Promise.all(referenceablePromises.map(p => p.promise)).then(() => {
                    dispatch(setAuditHistory(customDashboardData.sourceData))
                })
            })
            .catch(e => {
                if (e != "abortundefined") {
                    dispatch(loadingError("Something went wrong, please try again later."))
                }
            })
            .finally(() => {
                dispatch(finishAuditHistory())
            })
    }
}

export const startAuditHistory = () => {
    return { type: "START_AUDIT_HISTORY" }
}

export const setAuditHistory = response => {
    return {
        type: "GET_AUDIT_HISTORY",
        data: {
            response,
        },
    }
}

export const finishAuditHistory = () => {
    return { type: "FINISH_AUDIT_HISTORY" }
}

export const updateAuditFlag = isAudit => {
    return {
        type: "UPDATE_AUDIT_FLAG",
        data: {
            isAudit,
        },
    }
}

export const getAuditHistoryById = (resource, id, queryParams) => async dispatch => {
    const data = await getAuditHistoryByIdData(resource, id, queryParams)
    const referenceableIds = Array.from(data.reduce((set, row) => set.add(row["history_employee"]), new Set()))
    dispatch(loadAllReferenceableData("employees", referenceableIds))
    dispatch(referenceableDataSet({ employees: referenceableIds }))
    dispatch(auditHistoryByIdGet({ [resource]: data }, id))
}

export const auditHistoryByIdGet = (auditHistory, tagId) => {
    return {
        type: "GET_AUDIT_HISTORY_BY_ID",
        data: {
            auditHistory,
            tagId,
        },
    }
}

export const auditHistoryHideModal = () => {
    return {
        type: "HIDE_AUDIT_HISTORY_MODAL",
    }
}
